import React from 'react';
import {
  Button,
  Container,
  Grid,
  Header,
  Image,
  Segment,
  Icon,
  TableBody,
  Table,
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';

import editorUrlLine from '../img/editor-url-line.png';
import benjaminAvatar from '../img/benjamin_avatar.jpg';
import gabiAvatar from '../img/gabi_avatar.jpg';
import editorProjectView from '../img/editor-project-view.jpg';
import editorStoryView from '../img/editor-story-view.jpg';
import editorInspectorView from '../img/editor-inspector-view.jpg';
import editorSpeakerView from '../img/editor-speaker-view.jpg';
import editorPublishView from '../img/editor-publish-view.jpg';


import {FormattedMessage} from 'react-intl';
import InteractivePrice from './InteractivePrice';
import SvgEditorNoMoneyAds from '../img/editor-no-money-ads';
import SvgEditorNoProgramming from '../img/editor-no-programming';
  
const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            content='Editor'
            inverted
            style={{
            fontSize: mobile ? '2em' : '4em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        />
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.7em',
            fontWeight: 'normal',
            margin: '1em'
            }}
        >
            <FormattedMessage id="audory.editor.header.head" />
        </Header>
        <Button size='massive' color='green' href='https://editor.audory.io' target='_blank' onClick={() => {
            /*
            window.dataLayer.push({
                event: 'onWebsiteEvent',
                eventCategory: 'editorSite',
                eventAction: 'onButtonClick',
                eventLabel: 'EditorButtonHead',
                eventValue: 0
            });
            */
        }}>
            <FormattedMessage id="audory.editor.header.button" />
            <Icon name='right arrow' />
        </Button>
        </Container>
    </Segment>
)

const EditorPage = () => (
  <DivWrapper>
    <PageHeader />
    <Segment style={{ padding: '4em 0em', margin: 0 }}>
        
        <Container text>

            <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.editor.mainText.head" />
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.editor.mainText.body" />
            </p>
        </Container>
        <br/><br/><br/>
        <Grid container stackable verticalAlign='middle'>
            <Grid.Row>
                <Grid.Column width={8}>
                <Header as='h3' style={{ fontSize: '2em' }}>
                    <FormattedMessage id="audory.editor.table.head1" />
                </Header>
                <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                    <FormattedMessage id="audory.editor.table.body1" />
                </p>
                </Grid.Column>
                <Grid.Column floated='right' width={6}>
                <Image bordered rounded size='large' src={editorUrlLine} />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={8}>
                <Header as='h3' style={{ fontSize: '2em' }}>
                    <FormattedMessage id="audory.editor.table.head2" />
                </Header>
                <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                    <FormattedMessage id="audory.editor.table.body2" />
                </p>
                </Grid.Column>
                <Grid.Column floated='right' width={6} style={{textAlign: 'center'}}>
                    <SvgEditorNoProgramming />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={8}>
                    <Header as='h3' style={{ fontSize: '2em' }}>
                        <FormattedMessage id="audory.editor.table.head3" />
                    </Header>
                    <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                        <FormattedMessage id="audory.editor.table.body3" />
                    </p>
                </Grid.Column>
                <Grid.Column floated='right' width={6} style={{textAlign: 'center'}}>
                    <SvgEditorNoMoneyAds />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column textAlign='center'>
                <Button style={{marginTop: '2em'}} size='massive' color='green' href='https://editor.audory.io' target='_blank' onClick={() => {
                    /*
                    window.dataLayer.push({
                        event: 'onWebsiteEvent',
                        eventCategory: 'editorSite',
                        eventAction: 'onButtonClick',
                        eventLabel: 'EditorButton1',
                        eventValue: 0
                    });
                    */
                }}>
                    <FormattedMessage id="audory.editor.header.button" />
                    <Icon name='right arrow' />
                </Button>
                </Grid.Column>
            </Grid.Row>
        </Grid>

        <br/><br/><br/><br/><br/>

        <Container text>
            <InteractivePrice />
        </Container>

        <br/><br/><br/>
        <Grid columns={2} divided textAlign='center' stackable>
            <Grid.Column>
                <Grid.Row verticalAlign='middle'>
                    <Header as='h3' style={{ fontSize: '2em', padding: '1.5em', textAlign: 'justify' }}>
                        <FormattedMessage id="audory.editor.author1.comment" />
                    </Header>
                </Grid.Row>
                <Grid.Row verticalAlign='middle' style={{cursor: 'pointer'}} onClick={() => window.location.href = "/user/5ec587eb96393654df4f20e8"}>
                        <Image avatar style={{marginRight: '2em'}} src={gabiAvatar} size="tiny" />
                        <Table style={{ fontSize: '1.33em', margin: 'auto' }} collapsing basic='very'>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign='center'>
                                    <b>Gabriella Queen</b>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <FormattedMessage id="audory.editor.author1.description" />
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                </Grid.Row>
            </Grid.Column>
            <Grid.Column>
                <Grid.Row verticalAlign='middle'>
                    <Header as='h3' style={{ fontSize: '2em', padding: '1.5em', textAlign: 'justify' }}>
                        <FormattedMessage id="audory.editor.author2.comment" />
                    </Header>
                </Grid.Row>
                <Grid.Row verticalAlign='middle' style={{cursor: 'pointer'}} onClick={() => window.location.href = "/user/5f3fe8f75c8cb43a845e7af0"}>
                        <Image avatar style={{marginRight: '2em'}} src={benjaminAvatar} size="tiny" />
                        <Table style={{ fontSize: '1.33em', margin: 'auto' }} collapsing basic='very'>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign='center'>
                                    <b>Benjamin Spang</b>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <FormattedMessage id="audory.editor.author2.description" />
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                </Grid.Row>
            </Grid.Column>
            
        </Grid>
        <br/><br/><br/><br/><br/>
        <Container text>
            <Header as='h3' style={{ fontSize: '2em' }}>
                <FormattedMessage id="audory.editor.pic1.head" />
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.editor.pic1.body" />
            </p>
            <Image bordered rounded src={editorProjectView} />
            
            <Header as='h3' style={{ fontSize: '2em' }}>
                <FormattedMessage id="audory.editor.pic2.head" />
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.editor.pic2.body" />
            </p>
            <Image bordered rounded src={editorStoryView} />

            <Header as='h3' style={{ fontSize: '2em' }}>
                <FormattedMessage id="audory.editor.pic3.head" />
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.editor.pic3.body" />
            </p>
            <Image bordered rounded src={editorInspectorView} />

            <Header as='h3' style={{ fontSize: '2em' }}>
                <FormattedMessage id="audory.editor.pic4.head" />
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.editor.pic4.body" />
            </p>
            <Image bordered rounded src={editorSpeakerView} />

            <Header as='h3' style={{ fontSize: '2em' }}>
                <FormattedMessage id="audory.editor.pic5.head" />
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.editor.pic5.body" />
            </p>
            <Image bordered rounded src={editorPublishView} />

            <br/><br/><br/>

            <center>
                <Header as='h3' style={{ fontSize: '2em' }}>
                    <FormattedMessage id="audory.editor.callToAction.head" />
                </Header>
                <p style={{ fontSize: '1.33em' }}>
                    <FormattedMessage id="audory.editor.callToAction.body" />
                </p>
                
                <Button size='massive' color='green' href='https://editor.audory.io' target='_blank' onClick={() => {
                    /*
                    window.dataLayer.push({
                        event: 'onWebsiteEvent',
                        eventCategory: 'editorSite',
                        eventAction: 'onButtonClick',
                        eventLabel: 'EditorButton2',
                        eventValue: 0
                    });
                    */
                }}>
                    <FormattedMessage id="audory.editor.header.button" />
                    <Icon name='right arrow' />
                </Button>
            </center>
        </Container>
    </Segment>
    
    
  </DivWrapper>
)



export default EditorPage;


// WEBPACK FOOTER //
// ./src/components/EditorPage.js